import dashboardService from '@Dashboard/service/dashboard.service'
import HttpService from '@/utils/httpService';
import { ForgeInspection } from '@/scripts/js/forgeModels';
import { clearThemingColors, setPermeativeElementsTheme } from '@/utils/forgeUtils';
import store from '@/store';
import { log, error } from '@/utils/debugLogger';

const THREE = window.THREE;

export const DASHBOARD = {
    state: {
        units: [],
        loading: false,
        inspectionsTree: [],
        selectedUnits: JSON.parse(localStorage.getItem('selectedUnits')) || [],
        dashboardFlters: {},
        TMinSummary: null,
        RemaingLifeSummary: null,
        coloredInspections: [],
        isolatedInspectionsIds: [],
        coloredInspectionLoading:false
    },
    getters: {
        GET_COLORED_INSPECTION_LOADING(state){
           return state.coloredInspectionLoading;
        },
        GET_UNITS(state) {
            return state.units;
        },
        GET_LOADING(state) {
            return state.loading;
        },
        GET_INSPECTIONS_TREE(state) {
            return state.inspectionsTree;
        },
        GET_SELECTED_UNITS(state) {
            return state.selectedUnits;
        },
        GET_FILTERS(state) {
            return state.dashboardFlters;
        },
        GET_TMIN(state) {
            return state.TMinSummary
        },
        GET_REMAINING_LIFE(state) {
            return state.RemaingLifeSummary
        },
        GET_COLORED_INSPECTIONS(state) {
            return state.coloredInspections || [];
        },
        GET_ISOLATED_INSPECTIONS_IDS(state) {
            return state.isolatedInspectionsIds;
        },
    },
    mutations: {
        SET_COLORED_INSPECTION_LOADING(state, val) {
            state.coloredInspectionLoading = val;
        },
        SET_UNITS(state, units) {
            state.units = units;
        },
        SET_LOADING(state, loading) {
            state.loading = loading;
        },
        SET_INSPECTIONS_TREE(state, tree) {
            state.inspectionsTree = tree;
        },
        SET_SELECTED_UNITS(state, units) {
            state.selectedUnits = units
            localStorage.setItem('selectedUnits', JSON.stringify(units));
        },
        SET_FILTERS(state, filters) {
            state.dashboardFlters = filters
        },
        SET_TMIN(state, summary) {
            state.TMinSummary = summary
        },
        SET_REMAINING_LIFE(state, summary) {
            state.RemaingLifeSummary = summary
        },
        SET_COLORED_INSPECTIONS(state, inspections) {
            state.coloredInspections = inspections;
        },
        SET_ISOLATED_INSPECTIONS_IDS(state, ids) {
            state.isolatedInspectionsIds = ids;
        },
    },
    actions: {
        GET_INSPECTIONS_UNITS({ commit, dispatch }, assetId) {
            dashboardService.getUnits(assetId).then((response) => {
                let units = response.data
                    .filter((i) => i.pltName)
                    .map((i) => {
                        return { id: i.pltName, name: i.pltName, isChecked: true };
                    });
                // commit('SET_SELECTED_UNITS', units.filter((f) => f.isChecked))
                commit('SET_UNITS', units);
                dispatch('GET_AVAILABLE_CODES_API');
                dispatch('GET_UNITS_SUMMARY_API');
            })
                .catch((error) => {
                    log(error);
                })
                .finally(() => {
                    commit('SET_LOADING', false);
                });
        },

        GET_DASHBOARD_FILTERED_INSPECTION_TREE({ getters, commit }, { pagingModel, sortModel, assetId, searchText }) {
            let convertInf = (value) => {
                if (value == '-∞') return -10e9;
                if (value == '∞') return 10e9;
                return value;
            }

            if (sortModel?.colId == 'point') sortModel.colId = 'Point_X';

            let propertyFilter = getters.GET_SELECTED_INSPECTION_PROPERTY_FILTER_INDEX;
            let codes = [2, 3].includes(propertyFilter) ? getters.GET_INSPECTION_CODES_OPTIONS_SELECTED : [];
            let pressureFilters = [2, 3].includes(propertyFilter) && getters.GET_INSPECTION_TEMP_PRES_SELECTED_FILTER === 'Pressure' ? getters.GET_INSPECTION_PRESSURE_OPTIONS_SELECTED : [];
            let temperatureFilters = [2, 3].includes(propertyFilter) && getters.GET_INSPECTION_TEMP_PRES_SELECTED_FILTER === 'Temperature' ? getters.GET_INSPECTION_TEMPERATURE_OPTIONS_SELECTED : [];
            let filters = getters.GET_SELECTED_COLORS_OPTIONS;

            return new Promise((resolve, reject) => {
                return HttpService.post({
                    url: `api/dashboard/getInspectionTree`,
                    data: {
                        pagingModel,
                        sortModel,
                        search: searchText,
                        assetId: assetId,
                        propertyFilter: propertyFilter,
                        allowNull: getters.GET_IS_PROPERTY_ALLOW_NULL,
                        units: getters['GET_UNITS'].filter(o => o.isChecked).map(o => o.name),
                        codes: codes,
                        ColorsFilters: filters.map(o => {
                            return {
                                min: convertInf(o.judgCrr2),
                                minOps: o.judgMkr2,
                                max: convertInf(o.judgCrr1),
                                maxOps: o.judgMkr1,
                            }
                        }),
                        temperatureFilters: temperatureFilters.map(o => {
                            return {
                                min: convertInf(o.judgCrr2),
                                max: convertInf(o.judgCrr1),
                            }
                        }),
                        pressureFilters: pressureFilters.map(o => {
                            return {
                                min: convertInf(o.judgCrr2),
                                max: convertInf(o.judgCrr1),
                            }
                        }),
                    },
                }).then(response => {
                    commit('SET_INSPECTIONS_TREE', response.data.tree.children);
                    // let result = response.data.map(o => Object.assign(new ForgeInspection(), o));

                    // result.forEach(o => {
                    //     o.isFetched = true;
                    //     o.parseContent()
                    // });

                    // resolve(result);
                }).catch(error => {
                    log(error)
                    reject(error);
                })
            });
        },
        GET_DASHBOARD_AVALIABLE_FILTERS({ commit }, facilityId) {
            dashboardService.getAvailableFilters(facilityId).then((response) => {
                let filters = response.data
                commit('SET_FILTERS', filters);
            })
                .catch((error) => {
                    log(error);
                })
                .finally(() => {
                    commit('SET_LOADING', false);
                });
        },
        GET_COLORED_INSPECTIONS({commit},data){
            if (data.sortModel?.colId == 'point') data.sortModel.colId = 'Point.X';
            commit('SET_COLORED_INSPECTION_LOADING',true);
            return new Promise((resolve, reject) => {
                return HttpService.post({
                    url: `api/InspectionDashboard/ADNOC/GetFilteredInspections/colored/v2`,
                    data: data
                }).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    log(error)
                    reject(error);
                    
                }).finally(()=>{
                    commit('SET_COLORED_INSPECTION_LOADING',false);
                })
            });
        },
        GET_GRID_FILTERED_INSPECTIONS(_, data) {
            if (data.sortModel?.colId == 'point') data.sortModel.colId = 'Point.X';
            return new Promise((resolve, reject) => {
                return HttpService.post({
                    url: `api/InspectionDashboard/ADNOC/GetFilteredInspections/v2`,
                    data: data
                }).then(response => {

                    let result = response.data.items.map(o => Object.assign(new ForgeInspection(), o));

                    result.forEach(o => {
                        o.isFetched = true;
                        o.parseContent()
                    });

                    resolve(result);
                }).catch(error => {
                    log(error)
                    reject(error);
                })
            });
        },
        GET_TMIN_SUMMARY({ commit }, data) {
            dashboardService.getTMinSummary(data).then((response) => {
                commit('SET_TMIN', response.data);
            })
                .catch((error) => {
                    log(error);
                })
                .finally(() => {
                    commit('SET_LOADING', false);
                });
        },
        GET_REMAINING_LIFE_SUMMARY({ commit }, data) {
            dashboardService.getRemaingLifeSummary(data).then((response) => {
                commit('SET_REMAINING_LIFE', response.data);
            })
                .catch((error) => {
                    log(error);
                })
                .finally(() => {
                    commit('SET_LOADING', false);
                });
        },
        ISOLATE_COLORED_INSPECTIONS({ getters }, coloredInspections) {

            const viewer = store.state.viewer;

            let tree = viewer?.model?.getInstanceTree();

            if (!tree) {
                error('No tree found');
                return;
            }

            let themedDbIds = getters['GET_THEMED_DB_IDS'];

            if (themedDbIds?.length) clearThemingColors(viewer);

            let dbIds = [];

            if (!coloredInspections?.length)
                coloredInspections = [];

            coloredInspections.forEach((inspection) => {
                dbIds.push(...inspection.dbIds);

                let color = inspection.color;

                if (!color) return;

                color = new THREE.Color(color);
                color = new THREE.Vector4(color.r, color.g, color.b, 1);

                setPermeativeElementsTheme(inspection.dbIds, color);
            });

            store.commit('SET_ISOLATED_INSPECTIONS_IDS', coloredInspections.map(o => o.id));

            store.commit('SET_THEMED_DB_IDS', dbIds);

            store.state.forgeService.getMainExtension().isolateDbIds(dbIds, viewer.model);

            store.state.viewer.fitToView(dbIds);
        }
    }
} 